import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import SEO from "../../components/SEO";
import PageHero from "../../components/common/PageHero";
import { SERVICES } from "../../data/services";

export default function ServicesHubPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="bg-slate-50 min-h-screen">
      <SEO
        title="Coaching, Consulting, Mentorship & Speaking | Wisdom Peters"
        description="Book Wisdom Peters for private coaching, business consulting, custom mentorship, and speaking engagements."
        name="Wisdom Peters"
        type="website"
      />

      <PageHero
        eyebrow="Work With Wisdom"
        title="Services"
        subtitle="Coaching · Consulting · Mentorship · Speaking"
        backgroundImage="/pl 3.jpeg"
        overlayClass="bg-gradient-to-br from-black/80 via-purple-950/75 to-black/85"
        breadcrumbs={[
          { label: "Home", to: "/" },
          { label: "Services" },
        ]}
      />

      <section className="container mx-auto px-4 py-14 max-w-6xl -mt-2 relative z-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-800">
              Choose how you’d like to engage
            </h2>
            <p className="text-slate-500 mt-2 max-w-xl text-sm md:text-base">
              Dedicated pathways for private growth, organisational strategy,
              long-term mentorship, and events.
            </p>
          </div>
          <Link
            to="/book-session"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-purple-700 text-white font-semibold rounded-md hover:bg-purple-800 transition"
          >
            <Calendar className="w-4 h-4" />
            Book a Session
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {SERVICES.map(({ slug, title, summary, icon: Icon, image }) => (
            <Link
              key={slug}
              to={`/services/${slug}`}
              className="group bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-purple-300 hover:shadow-lg transition-all"
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="p-2 bg-purple-100 rounded-lg">
                    <Icon className="w-5 h-5 text-purple-700" />
                  </div>
                  <h3 className="font-bold text-slate-800 group-hover:text-purple-800 transition-colors">
                    {title}
                  </h3>
                </div>
                <p className="text-slate-500 text-sm leading-relaxed mb-4">
                  {summary}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-purple-700">
                  Explore <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
